import React from 'react';
import {connect} from 'react-redux';
import Moment from 'react-moment';
import {RangeArrowIcon} from '~/Components/Icons/Icons';
import TextTranslate, { TextTranslateString } from '../../Components/TextTranslate/TextTranslate';

const HotelRooms = ({guest, index, currentLanguage, translations, ...props}) => {

    const roomTypes = {
        '': TextTranslateString('hotel-room-type', 'None', currentLanguage, translations),
        'single': TextTranslateString('hotel-room-type-single', 'Single', currentLanguage, translations),
        'twin': TextTranslateString('hotel-room-type-twin', 'Twin', currentLanguage, translations),
        'double': TextTranslateString('hotel-room-type-double', 'Double', currentLanguage, translations),
    }

    return (
        <div className="guest-personal-details">
            <div className="row">
                <div className="col-lg-4 col-12">
                    <label><TextTranslate name="form-hotel-accomodation" fallback="Your accommodation"/></label>
                </div>
                <div className="col-lg-8 col-12">
                    <p>
                        {guest.requirement.hotel_required ?
                            <TextTranslate name="hotel-room-require-yes" fallback="Yes, I require a hotel room(s)"/> :
                            <TextTranslate name="hotel-room-require-no" fallback={`No, I do not require a hotel room(s)`}/>
                        }
                    </p>
                </div>
            </div>

            {(guest.requirement.hotel_required && guest.requirement.hotel_required) && (
                <>
                    <hr />
                    <div className="row">
                        <div className="col-lg-4 col-12">
                            <label><TextTranslate name="hotel-your-requirements" fallback="Your requirements"/></label>
                        </div>
                        <div className="col-lg-8 col-12">
                            {guest.hotel_rooms.map((room, key) => {
                                return (
                                    <div key={key} className="row room">
                                        <div className="col-lg-4 col-12">
                                            <p>{room.qty} x <span className="text-capitalize">{roomTypes[room.room_type]}</span> <TextTranslate name="word-room" fallback="Room" textOnly/></p>
                                        </div>
                                        <div className="col-lg-8 col-12">
                                            <p><Moment locale={currentLanguage?.code || 'en'} format="MMM Do YY">{room.date_from}</Moment></p>
                                            <RangeArrowIcon className={currentLanguage?.rtl ? 'flip-horizontal' : ''} />
                                            <p><Moment locale={currentLanguage?.code || 'en'} format="MMM Do YY">{room.date_to}</Moment></p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </>
            )}

            {(guest.requirement.hotel_required && guest.hotel_rooms.length > 1) && (
                <>
                    <hr/>
                    <div className="row">
                        <div className="col-lg-4 col-12">
                            <label>Justification</label>
                        </div>
                        <div className="col-lg-8 col-12">
                            <p>{guest.requirement.hotel_justification || 'No justification.'}</p>
                        </div>
                    </div>
                </>
            )}

            {(guest.requirement.hotel_required && guest.requirement.hotel_comments) &&(
                <>
                    <hr/>
                    <div className="row">
                        <div className="col-lg-4 col-12">
                            <label><TextTranslate name="word-comments" fallback="Comments"/></label>
                        </div>
                        <div className="col-lg-8 col-12">
                            <p>{guest.requirement.hotel_comments || 'No comments.'}</p>
                        </div>
                    </div>
                </>
            )}

        </div>
    )
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
    translations: state.translations?.translations,
});

export default connect(mapStateToProps)(HotelRooms);